export const checkPoint = {
  strict: process.env.NODE_ENV === 'local',
  namespaced: true,
  state: {
    checkAvailablePoint: 0,
    lecheckDownloadAvailablePoint: 0
  },
  getters: {
    checkAvailablePoint: state => state.checkAvailablePoint,
    lecheckDownloadAvailablePoint: state => state.lecheckDownloadAvailablePoint
  },
  mutations: {
    setCheckAvailablePoint(state, point) {
      state.checkAvailablePoint = point;
    },
    setLecheckDownloadAvailablePoint(state, point) {
      state.lecheckDownloadAvailablePoint = point;
    },
    clearCheckAvailablePoint(state) {
      state.checkAvailablePoint = 0;
    },
    clearLecheckDownloadAvailablePoint(state) {
      state.lecheckDownloadAvailablePoint = 0;
    }
  },
  actions: {
    clear({ commit }) {
      commit('clearCheckAvailablePoint');
      commit('clearLecheckDownloadAvailablePoint');
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/checkPoint.js